import React from "react";
import { formatDateTime } from "../../utils/date";

const AnalyticsPaymentHistory = ({ payments = [] }) => {
    if (!payments.length) {
        return (
            <div className="flex flex-col items-center justify-center gap-2 rounded-xl border border-dashed border-gray-200 py-10 text-center">
                <div className="text-2xl">💳</div>
                <div className="text-sm font-medium text-gray-500">No payments yet</div>
                <div className="text-xs text-gray-400">
                    Completed transactions will appear here.
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-2">
            {payments.map((payment, index) => (
                <div
                    key={index}
                    className="flex items-center gap-4 rounded-xl border border-gray-200 bg-white p-4 transition hover:border-gray-300 hover:shadow-sm"
                >
                    {/* Icon */}
                    <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-green-50 text-green-600">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/>
                        </svg>
                    </div>

                    {/* Info */}
                    <div className="flex-1 min-w-0">
                        <div className="truncate text-[13px] font-medium text-gray-900">
                            {payment.product}
                        </div>
                        <div className="mt-0.5 text-[11px] text-gray-400">
                            {payment.gateway}
                        </div>
                        <span className="mt-1.5 inline-flex items-center gap-1 rounded-md bg-green-50 px-2 py-0.5 text-[11px] font-medium text-green-700">
                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <polyline points="20 6 9 17 4 12"/>
                            </svg>
                            {payment.status}
                        </span>
                    </div>

                    {/* Amount */}
                    <div className="flex-shrink-0 text-right">
                        <div className="text-[18px] font-medium text-green-700">
                            ${Number(payment.amount).toLocaleString("en-IN")}
                        </div>
                        <div className="mt-0.5 text-[11px] text-gray-400">
                            {formatDateTime(payment.paid_at)}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default AnalyticsPaymentHistory;